import noop from 'lodash/noop';
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { BaseIcon as Icon } from '@zocdoc-frontend-common/assets-icons';
import { getStarRatingFromMouseEvent } from './utils';

const SVG = styled(Icon).attrs({ viewBox: '0 0 243 40' })`
    font-size: ${(p) => (p.height ? `${p.height}px` : '1em')};
    height: 1em;
    width: 6.075em;
    display: block;
`;

/**
 * @param {function(stars: number): void} onStarClick
 * @param {function(): void} onMouseLeave
 * @param {function(): void} onStarMouseEnter
 * @param {number} rating
 * @param {boolean} selected
 * @param {{
 *     comopnents: {
 *         Stars: {
 *             filledColor: string,
 *             unfilledColor: string,
 *         },
 *     },
 * }} theme
 * @returns {JSX.Element}
 * @deprecated Use the mezzanine component '@zocdoc-mezzanine/components-ratings'
 */
class Stars extends React.PureComponent {
    static defaultProps = {
        onClick: noop, // NOTE: This is for backwards compatibility
        onStarClick: noop,
        onStarMouseEnter: noop,
        onMouseLeave: noop,
        selected: true,
    };

    constructor(props) {
        super(props);

        this.svgStarsRef = React.createRef();
    }

    render() {
        const {
            rating,
            theme: {
                components: {
                    Stars: { filledColor, unfilledColor },
                },
            },
            selected,
            onClick,
        } = this.props;

        const roundedRating = this.round(rating);
        let paths;

        const opacity = selected ? 1 : 0.8;

        switch (roundedRating) {
            case 5:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                    </g>
                );
                break;

            case 4.5:
                paths = (
                    <g>
                        <path
                            d="M221.5 31.2L210.8 40l-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h2.9"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40z"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M221.5 0h2.3l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.7-11.3-8.3"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 4:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40z"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M232.2 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 3.5:
                paths = (
                    <g>
                        <path
                            d="M171.5 31.2L160.8 40l-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169.2 0h2.9"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M232.2 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zM171.5 0h2.3l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.7-11.3-8.3"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 3:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M182 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 2.5:
                paths = (
                    <g>
                        <path
                            d="M121.5 31.2L110.8 40l-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h2.9"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M182 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zM121.5 0h2.3l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.7-11.3-8.3"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 2:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M132.2 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 1.5:
                paths = (
                    <g>
                        <path
                            d="M71.5 31.2L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h2.9"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M132.2 40l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zM71.5 0h2.3l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6-11.3-8.3"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 1:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M82.2 40l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            case 0.5:
                paths = (
                    <g>
                        <path
                            d="M21.5 31.2L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h2.9"
                            fill={filledColor}
                            fillOpacity={opacity}
                        />
                        <path
                            d="M82.2 40l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zM21.5 0h2.3l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6-11.3-8.3"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;

            default:
                paths = (
                    <g>
                        <path
                            d="M32.2 40l-10.7-7.8L10.8 40l-3.7-2.7 4.1-12.6L.5 17l1.4-4.4h13.2L19.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8L60.8 40l-3.7-2.7 4.1-12.6L50.5 17l1.4-4.4h13.2L69.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm50 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L119.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6zm49.8 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L169 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6L182 40zm50.2 0l-10.7-7.8-10.7 7.8-3.7-2.7 4.1-12.6-10.7-7.7 1.4-4.4h13.2L219.2 0h4.6l4.1 12.6h13.2l1.4 4.4-10.7 7.8 4.1 12.6-3.7 2.6z"
                            fill={unfilledColor}
                        />
                    </g>
                );
                break;
        }

        return (
            <StarSvgWrapper
                className={this.props.className}
                data-test={this.props['data-test']}
                onClick={onClick}
            >
                <div /* DO NOT APPLY STYLES TO THIS DIV... EVER!!! */
                    data-test="stars-svg-wrapper"
                    ref={this.svgStarsRef}
                    onMouseMove={this.handleMouseMove}
                    onMouseLeave={this.handleStarMouseLeave}
                    onClick={this.handleStarClick}
                >
                    <SVG
                        data-rating={roundedRating}
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        {paths}
                    </SVG>
                </div>
            </StarSvgWrapper>
        );
    }

    handleStarClick = (event) => {
        const { onStarClick } = this.props;

        const rating = getStarRatingFromMouseEvent(event, this.svgStarsRef);
        onStarClick(rating);
    };

    handleStarMouseLeave = () => {
        const { onMouseLeave } = this.props;
        onMouseLeave();
    };

    handleMouseMove = (event) => {
        const { onStarMouseEnter } = this.props;

        const rating = getStarRatingFromMouseEvent(event, this.svgStarsRef);
        onStarMouseEnter(rating);
    };

    round(rating) {
        const rounded = Math.round(rating * 2) / 2;

        if (rounded < 0) {
            return 0;
        } else if (rounded > 5) {
            return 5;
        } else {
            return rounded;
        }
    }
}

const StarSvgWrapper = styled.div`
    display: inline-block;
`;

/**
 * @deprecated Use the mezzanine component '@zocdoc-mezzanine/components-ratings'
 */
export default withTheme(Stars);
